export const en = {
  nav: {
    home: "Home",
    projects: "Projects",
    services: "Services",
    about: "About Us",
    brands: "Brands",
    contact: "Contact",
    cta: "Start Your Project",
    langLabel: "Language:",
    whatsapp: "WhatsApp",
    email: "Email"
  },
  footer: {
    description: "Creative communication agency unifying strategy, design, cinema production, and modern software engineering under one roof.",
    servicesTitle: "Our Services",
    quickLinksTitle: "Quick Links",
    contactTitle: "Contact Us",
    address: "Meşrutiyet Mah., Şehit İsmet Armağan Sok., No: 7, Nişantaşı, Şişli, Istanbul",
    whatsappBtn: "Chat on WhatsApp",
    allRightsReserved: "All rights reserved.",
    privacy: "Privacy Policy",
    kvkk: "KVKK & Data Protection",
    cookie: "Cookie Policy"
  },
  home: {
    heroTag: "WE24 - CREATIVE COMMUNICATION AGENCY",
    heroTitle: "Transforming ideas into imagery, brands into impact.",
    heroSubtitle: "From high-end cinema production to post-production, digital media strategy, and bespoke software, we engineer the entire brand journey under one roof.",
    exploreProjects: "Explore Projects",
    contactUs: "Discuss Your Project",
    featuredProjectsTitle: "Selected Works",
    featuredProjectsSubtitle: "Curated showcase of commercials, live broadcasts, and digital platforms produced for industry leaders.",
    viewAllProjects: "View All Projects",
    capabilitiesTitle: "What We Do",
    capabilitiesSubtitle: "Specializing across creative and digital production disciplines to solve complex brand communication challenges.",
    processTitle: "Production Workflow",
    processSubtitle: "Target-driven, transparent, and agile production model engineered for speed and aesthetic excellence.",
    metricsTitle: "WE24 in Numbers",
    ctaTitle: "Let's create your next milestone together.",
    ctaSubtitle: "Whether a commercial film, live broadcast, digital growth campaign, or bespoke web platform - let's construct the right production framework.",
    ctaBtn: "Tell Us About Your Project"
  },
  services: {
    title: "Our Services",
    subtitle: "Positioning your brand at the forefront of the digital world with an integrated model combining strategy, design, production, and technology.",
    categoryLabel: "Category",
    exploreDetails: "Explore Details",
    allServices: "All Services",
    startNow: "Get Started",
    scopeTitle: "Scope & Capabilities",
    deliverablesTitle: "Deliverables & Master Assets",
    processTitle: "Production Process",
    techSpecsTitle: "Technology, Equipment & Infrastructure",
    faqTitle: "Frequently Asked Questions",
    relatedProjectsTitle: "Selected Case Studies for This Service",
    notFound: "Service Not Found",
    notFoundDesc: "The requested service category does not exist in our index.",
    backToList: "Back to Services List"
  },
  projects: {
    title: "Our Works",
    subtitle: "Selected projects executed across film production, digital campaigns, live broadcast switchers, design, and software engineering.",
    all: "All",
    filterByCategory: "Filter by Category",
    client: "Client / Brand",
    year: "Year",
    services: "Services Provided",
    viewProject: "View Project",
    searchPlaceholder: "Search project or client...",
    sortBy: "Sort by:",
    featured: "Featured",
    newest: "Newest",
    alpha: "A - Z",
    notFound: "No Projects Found",
    notFoundDesc: "No projects match the selected filter or search term. Reset your filters to view all works.",
    clearFilters: "Clear Filters",
    backToProjects: "Back to All Projects",
    nextProject: "Next Project"
  },
  projectDetail: {
    backToProjects: "Back to Projects",
    projectDetails: "Project Details",
    client: "Client",
    year: "Year",
    category: "Category",
    projectTeam: "Project Team",
    relatedProjects: "You May Also Like",
    notFound: "Project Not Found",
    notFoundDesc: "We could not locate this project or it may have been archived."
  },
  about: {
    tag: "About Us",
    title: "Diverse disciplines.\nUnified creative mind.",
    subtitle: "Over 15 years of cumulative production experience spanning hundreds of events, corporate films, concerts, music videos, and digital platforms.",
    storyTitle: "Our Story & Hybrid Model",
    storyP1: "We eliminate the cumbersome handoffs of legacy advertising agencies. From creative strategy and lighting rigs to post-production editing suites and frontend web code, our in-house specialists execute every stage with precision.",
    storyP2: "Consistency, technical polish, and speed define great modern brands. We carry the visual soul of a filmed commercial directly into the user interface of your web platform and sustain that cinematic fidelity across social channels.",
    valuesTitle: "Core Values",
    teamTitle: "The Creative Mind Behind Production",
    studioTitle: "Studio & Technical Infrastructure",
    studioSubtitle: "Empowering production excellence through calibrated hardware and isolated acoustic studio facilities.",
    manifesto: "Strategy, optics, code, and editorial precision under one roof."
  },
  brands: {
    tag: "Brand Partners",
    title: "Brands We Build Together",
    subtitle: "Valued brand partners for whom we have produced cinematic production, strategy, and digital experiences."
  },
  contact: {
    tag: "Contact",
    title: "What can we build together?",
    subtitle: "Have an upcoming project? Submit your brief using the form or reach out directly to our Istanbul studio.",
    phone: "Phone",
    email: "Email",
    address: "Studio Address",
    directMessage: "Prefer direct messaging?",
    whatsappBtn: "Chat on WhatsApp",
    whatsappDirect: "Chat on WhatsApp",
    formTitle: "Project Brief Form",
    fullName: "Full Name",
    company: "Brand / Company",
    emailField: "Email Address",
    phoneField: "Phone Number",
    service: "Service of Interest",
    selectService: "Select a service...",
    timeline: "Estimated Timeline",
    selectTimeline: "Select timeline...",
    budget: "Estimated Budget",
    selectBudget: "Select budget range...",
    summary: "Project Summary",
    submit: "Send Proposal Request",
    formSuccessTitle: "Request Received",
    formSuccessDesc: "Thank you for reaching out. Our core team will evaluate your brief and contact you shortly.",
    sendNewForm: "Send Another Request"
  }
};
